import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import '@/styles/globals.css'
import { initObservability } from '@/lib/observability/sentry'
import { reportWebVitals } from '@/lib/observability/vitals'
import { initStaleChunkReload } from '@/app/staleChunkReload'

initStaleChunkReload()
initObservability()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

reportWebVitals()
